import { InjectionToken } from '@angular/core';

/**
 * Optional loader for the DotLottie player. When provided by the app, the typing indicator
 * uses it to play .lottie animations. If not provided, the chat falls back to the 3-dots indicator.
 *
 * App usage (e.g. in app.config):
 *   import { DOTLOTTIE_LOADER } from '@qtek/libs/ai-chat';
 *   provide(DOTLOTTIE_LOADER, { useValue: () => import('@lottiefiles/dotlottie-web').then(m => m.DotLottie) })
 */
export const DOTLOTTIE_LOADER = new InjectionToken<() => Promise<unknown>>(
  'DOTLOTTIE_LOADER'
);
